<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div *ngIf="versicherungsnehmer; else partner">
    <div class="mt-3" [id]="idprefix + '_versicherungsnehmer'">
      <ng-template #versicherungsnehmerTitleTemplate>
        <h6>Versicherungsnehmer</h6>
      </ng-template>
      <div *ngIf="expertMode; else versicherungsnehmerTitle">
        <div class="row">
          <div class="col col-xs-12 col-sm-6">
            <ng-template [ngTemplateOutlet]="versicherungsnehmerTitleTemplate"></ng-template>
          </div>
          <div class="col col-xs-12 col-sm-6 text-right">
            <button mat-button class="button--primary icon--after icon--right" (click)="versicherungsnehmerListDialogService.openDialog($event, this, showEinzelunternehmen, validateAlter)">VN suchen</button>
          </div>
        </div>
        <div class="row" *ngIf="!expertMode">
          <div class="col col-xs-12 col-sm-12">
            <div class="teaser" *ngIf="(translateService.get('VERTRIEBSPARTNERMAILINFO') | async) as res" [innerHTML]="res"></div>
          </div>
        </div>
      </div>
      <ng-template #versicherungsnehmerTitle>
        <ng-template [ngTemplateOutlet]="versicherungsnehmerTitleTemplate"></ng-template>
      </ng-template>
      <ng-template [ngTemplateOutlet]="partnerTemplate"></ng-template>
    </div>
  </div>
  <ng-template #partner>
    <ng-template [ngTemplateOutlet]="partnerTemplate"></ng-template>
  </ng-template>
  <ng-template #partnerTemplate>
    <div *ngIf="showAnrede">
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <div class="input_radio">
            <app-label [control]="anrede" [for]="idprefix + '_anrede'">Anrede {{ showEinzelunternehmen ? ' (Ein-Personen-Unternehmen)' : '' }}:</app-label>
            <mat-radio-group [id]="idprefix + '_anrede'" formControlName="anrede">
              <mat-radio-button *ngFor="let anrede of getAnreden() | keyvalue" [value]="anrede.key">{{ anrede.value }}</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="anrede.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showName">
      <div class="row">
        <div class="col col-xs-12 col-sm-2" *ngIf="!student">
          <div class="input">
            <div class="text_info">
              <app-label [control]="titelPrefix" class="custom-select__label" [for]="idprefix + '_titelPrefix'" [control]="titelPrefix">Titel:</app-label>
              <div class="info">
                <div class="info_trigger_placeholder">&nbsp;</div>
              </div>
            </div>
            <mat-form-field>
              <mat-select [id]="idprefix + '_titelPrefix'" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="titelPrefix">
                <mat-option></mat-option>
                <mat-option *ngFor="let t of dataService.getTitelPrefix() | keyvalue:prefixSort" [value]="t.key">{{ t.value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col col-xs-12" [ngClass]="{' col-sm-4': !student, ' col-sm-6': student}">
          <div class="input">
            <div class="text_info">
              <app-label [control]="vorname" class="input__label" [for]="idprefix + '_vorname'" [control]="vorname">Vorname:</app-label>
              <div class="info">
                <div class="info_trigger_placeholder">&nbsp;</div>
              </div>
            </div>
            <mat-form-field>
              <input matInput [id]="idprefix + '_vorname'" maxlength="35" formControlName="vorname">
              <mat-error *ngIf="vorname.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="vorname.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col col-xs-12" [ngClass]="{' col-sm-4': !student, ' col-sm-6': student}">
          <div class="input">
            <div class="text_info">
              <app-label [control]="nachname" class="input__label" [for]="idprefix + '_nachname'">Nachname:</app-label>
              <div class="info">
                <div class="info_trigger_placeholder">&nbsp;</div>
              </div>
            </div>
            <mat-form-field>
              <input matInput [id]="idprefix + '_nachname'" maxlength="35" formControlName="nachname">
              <mat-error *ngIf="nachname.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="nachname.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-2" *ngIf="!student">
          <div class="input">
            <div class="text_info">
              <app-label [control]="titelSuffix" class="custom-select__label" [for]="idprefix + '_titelSuffix'">Titel:</app-label>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('TITELSUFFIXINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
            <mat-form-field>
              <mat-select [id]="idprefix + '_titelSuffix'" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="titelSuffix">
                <mat-option></mat-option>
                <mat-option *ngFor="let t of dataService.getTitelSuffix() | keyvalue" [value]="t.key">{{ t.value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showFirmenname">
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <div class="input">
            <app-label [control]="firmenname" class="input__label" [for]="idprefix + '_firmenname'">Firmenname:</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_firmenname'" maxlength="35" formControlName="firmenname">
              <mat-error *ngIf="firmenname.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <app-adresse #_adresse [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="adresse" [idprefix]="idprefix" [required]="true" [showGroup]="showGroup"></app-adresse>
    <div formGroupName="emailGroup" *ngIf="showEmailGroup">
      <div class="row">
        <div class="col col-xs-12 col-sm-6">
          <div class="input">
            <app-label [control]="email" class="input__label" [for]="idprefix + '_email'">{{ versicherungsnehmer === true ? 'E-Mail Versicherungsnehmer:' : 'E-Mail:' }}</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_email'" maxlength="70" formControlName="email">
              <mat-error *ngIf="email.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="email.hasError('email')">{{ 'INPUTINVALID' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-6">
          <div class="input">
            <app-label [control]="confirmEmail" class="input__label" [for]="idprefix + '_confirmEmail'">{{ versicherungsnehmer === true ? 'E-Mail Versicherungsnehmer bestätigen:' : 'E-Mail bestätigen:' }}</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_confirmEmail'" maxlength="70" formControlName="confirm" [errorStateMatcher]="matcher" appBlockcopypaste>
              <mat-error *ngIf="confirmEmail.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="confirmEmail.hasError('email')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="emailGroup.hasError('mismatchEmail') && !confirmEmail.hasError('required') && !confirmEmail.hasError('email')">{{ 'INPUTMISMATCH' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showGroup">
      <div *ngIf="showGeburtsdatum; else _telefonnummer">
        <div class="row">
          <div class="col col-xs-12 col-sm-6">
            <ng-template *ngTemplateOutlet="telefonnummerTemplate"></ng-template>
          </div>
          <div class="col col-xs-12 col-sm-6">
            <div class="input">
              <app-label [control]="geburtsdatum"  class="input-date-picker__label" [for]="idprefix + '_geburtsdatum'">Geburtsdatum:</app-label>
              <mat-form-field>
                <input matInput [id]="idprefix + '_geburtsdatum'" [matDatepicker]="geburtsdatumPicker" placeholder="TT.MM.JJJJ" formControlName="geburtsdatum">
                <mat-datepicker-toggle matSuffix [for]="geburtsdatumPicker"></mat-datepicker-toggle>
                <mat-datepicker #geburtsdatumPicker></mat-datepicker>
                <mat-error *ngIf="geburtsdatum.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
                <mat-error *ngIf="geburtsdatum.hasError('geburtsdatum')">{{ 'INPUTMAXAGE' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <ng-template #_telefonnummer>
        <div class="row">
          <div class="col col-xs-12 col-sm-12">
            <ng-template *ngTemplateOutlet="telefonnummerTemplate"></ng-template>
          </div>
        </div>
      </ng-template>
    </div>
    <ng-template #telefonnummerTemplate>
      <div class="input">
        <app-label [control]="telefonnummer"  class="input__label" [for]="idprefix + '_telefonnummer'">Telefonnummer (tagsüber):</app-label>
        <mat-form-field>
          <input matInput [id]="idprefix + '_telefonnummer'" maxlength="70" formControlName="telefonnummer">
        </mat-form-field>
      </div>
    </ng-template>
  </ng-template>
</form>
